
// import { createStore, combineReducers, compose } from 'redux'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/storage'
// import { reduxFirestore, firestoreReducer } from 'redux-firestore'

const firebaseConfig = require('../json/firebase.json')
firebase.initializeApp(firebaseConfig)

export default firebase;


// WEBPACK FOOTER //
// ./src/redux/store.js